import styled from "styled-components";
import { leftColumnWidth, tileHeight } from "../../../constants";
import { marginPaddingReset, truncate } from "../../../styles";
import { StyledTextProps } from "./types";

export const StyledTileWrapper = styled.button`
  ${marginPaddingReset}
  height: ${tileHeight}px;
  position: absolute;
  outline: none;
  border: none;
  border-radius: 4px;
  text-align: left;
  color: ${({ theme }) => theme.colors.textPrimary};
  width: 100%;
  cursor: pointer;
`;

export const StyledTextWrapper = styled.div`
  margin: 10px 16px;
  position: relative;
  display: flex;
  font-size: 0.625rem;
  letter-spacing: 0.5px;
  line-height: 12px;
`;

export const ContainerStyledText = styled.div`
  overflow: hidden;
  white-space: normal;  
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-wrap: nowrap;
`

export const StyledText = styled.p<StyledTextProps>`
  ${marginPaddingReset}
  ${truncate}
  font-size: 0.75rem;
  display: inline;
  text-shadow: 0px 0px rgba(0,0,0, 1);
  font-weight: ${({ bold }) => (bold ? "600" : "400")};
`;

export const StyledDescription = styled.p`
  ${marginPaddingReset}
  ${truncate}
  display: flex;
  align-items: center;
  gap: 4px;

  > svg {
    min-width: 13px;
    min-height: 13px;
  }
  
  > span {
    overflow: hidden;
    white-space: normal;  
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
`;

export const StyledStickyWrapper = styled.div`
  position: sticky;
  left: ${leftColumnWidth + 16}px;
  overflow: hidden;
`;
